module.exports = "<p>\n  cases-import works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cases/views/cases-import.component.html
// module id = ./src/app/modules/cases/views/cases-import.component.html
// module chunks = main